module.exports = __webpack_public_path__ + "static/img/seas_not.68f3f488.png";